module.exports = __webpack_public_path__ + "static/media/pg.5b6fb535.jpg";